import {AbstractControl, ValidationErrors} from '@angular/forms';

export function patternIgnoreSpaces(pattern: RegExp) {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }

        const value = control.value.replace(/\s/g,'');

        return pattern.test(value) ? null : {patternMismatch: true};
    }
}
